import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {environment} from '../../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class ReportProblemService {
  scheduleErrorTypeUrl: string
  scheduleErrorUrl: string

  constructor(private http: HttpClient) {
    const apiUrl = environment.apiUrl
    this.scheduleErrorTypeUrl = `${apiUrl}/schedule-error-types`
    this.scheduleErrorUrl = `${apiUrl}/schedule-errors`
  }

  getScheduleErrorTypes() {
    return this.http.get<any>(this.scheduleErrorTypeUrl)
  }

  getScheduleErrors(eventIds: string[]) {
    return this.http.post<any>(`${this.scheduleErrorUrl}/list`, {eventIds})
  }

  saveErrors(payload: ReportProblem) {
    const url = `${this.scheduleErrorUrl}`
    return this.http.post<any>(url, payload)
  }

  searchReport(body: any) {
    return this.http.post<any[]>(`${this.scheduleErrorUrl}/search`, body)
  }

  export(body: any) {
    return this.http.post(`${this.scheduleErrorUrl}/export`, body, { observe: 'response', responseType: 'arraybuffer' })
  }
}
